import {
    TrialAssistantRoutes,
    DefaultAssistantRoutes,
    TrialAdminRoutes,
    DefaultAdminRoutes
} from "../../../components/routes/routers.comp";
import { App } from "../../interfaces/comps/app.interface";
import { MenuItem } from "../../interfaces/comps/menu-item.interface";
import { Env } from "../../enums/env.enum";
import { Logo } from "../../enums/logo.enum";
import { Theme } from "../../enums/theme.enum";
import { FileType } from "../../enums/file-type.enum";

export const APPS: App[] = [
    {
        subdomains: [Env.trial],
        routes: TrialAssistantRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        logo: Logo.default,
        headerLogo: Logo.default,
        color: "#C90735",
        adminPanel: false,
        trialMode: true,
        devMode: false,
        main: false
    },
    {
        subdomains: [`admin.${Env.trial}`],
        routes: TrialAdminRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.default,
        color: "#C90735",
        adminPanel: true,
        trialMode: true,
        devMode: false,
        main: false
    },
    {
        subdomains: [Env.sales, Env.lafon, `ken`],
        routes: DefaultAssistantRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.default,
        color: "#C90735",
        adminPanel: false,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [`admin.${Env.sales}`, `admin.${Env.lafon}`, `admin.ken`],
        routes: DefaultAdminRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.default,
        color: "#C90735",
        adminPanel: true,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [Env.epic],
        routes: DefaultAssistantRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.comet,
        color: "#0F426B",
        adminPanel: false,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [`admin.${Env.epic}`],
        routes: DefaultAdminRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.comet,
        color: "#0F426B",
        adminPanel: true,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [Env.mba],
        routes: DefaultAssistantRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.mba,
        logo: Logo.mba,
        color: "#55A0D7",
        adminPanel: false,
        trialMode: false,
        devMode: false,
        main: true
    },
    {
        subdomains: [`admin.${Env.mba}`],
        routes: DefaultAdminRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.mba,
        logo: Logo.mba,
        color: "#55A0D7",
        adminPanel: true,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [Env.mgtdsStudent],
        routes: DefaultAssistantRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.mgt,
        color: "#002D62",
        adminPanel: false,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [`admin.${Env.mgtdsStudent}`],
        routes: DefaultAdminRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.mgt,
        color: "#002D62",
        adminPanel: true,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [Env.mgtdsInstructor],
        routes: DefaultAssistantRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.mgt,
        color: "#002D62",
        adminPanel: false,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [`admin.${Env.mgtdsInstructor}`],
        routes: DefaultAdminRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.mgt,
        color: "#002D62",
        adminPanel: true,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [Env.nanci],
        routes: DefaultAssistantRoutes,
        lightTheme: Theme.lightNanci,
        darkTheme: Theme.darkNanci,
        headerLogo: Logo.nanci,
        logo: Logo.nanci,
        color: "linear-gradient(128deg, #12252C 0.6%, #2A4F5F 100%)",
        adminPanel: false,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: [`admin.${Env.nanci}`],
        routes: DefaultAdminRoutes,
        lightTheme: Theme.lightNanci,
        darkTheme: Theme.darkNanci,
        headerLogo: Logo.nanci,
        logo: Logo.nanci,
        color: "linear-gradient(128deg, #12252C 0.6%, #2A4F5F 100%)",
        adminPanel: true,
        trialMode: false,
        devMode: false,
        main: false
    },
    {
        subdomains: ["", "dev.comet", "stage.comet"],
        routes: DefaultAssistantRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.default,
        color: "#C90735",
        adminPanel: false,
        trialMode: false,
        devMode: true,
        main: false
    },
    {
        subdomains: ["admin", "admin.dev.comet", "admin.stage.comet"],
        routes: DefaultAdminRoutes,
        lightTheme: Theme.light,
        darkTheme: Theme.dark,
        headerLogo: Logo.default,
        logo: Logo.default,
        color: "#C90735",
        adminPanel: true,
        trialMode: false,
        devMode: true,
        main: false
    }
];

export const emailRegex = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/g;

export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export const fileTypes: MenuItem<string>[] = Object.values(FileType).map(type => {
    switch (type) {
        case FileType.txt:
            return { label: "Txt", value: FileType.txt } as MenuItem<string>;
        case FileType.pdf:
            return { label: "Pdf", value: FileType.pdf } as MenuItem<string>;
        case FileType.mp3:
            return { label: "Mp3", value: FileType.mp3 } as MenuItem<string>;
        case FileType.mp4:
            return { label: "Mp4", value: FileType.mp4 } as MenuItem<string>;
    }
});

export const trialFileTypes: MenuItem<string>[] = [
    { label: "Txt", value: FileType.txt },
    { label: "Pdf", value: FileType.pdf }
];

export const defaultAssistantSettings = {
    title: "How can I help you?",
    description:
        "Here are some examples of what you can ask Knowledge Base (click to try),\nalso you can type or say a prompt below.",
    sampleQuestions: [
        "How to register for PowerSchool?",
        "How to enter grades in PowerSchool?",
        "What is the next star literacy testing window for the 2nd grade?",
        "How to access Star Reports?",
        "What benchmarks do 3rd grade students take?",
        "When does the spring benchmark window begin?"
    ]
};
